/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import classnames from 'classnames';
import React from 'react';

function Help({
	children,
	className,
	...otherProps
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			{...otherProps}
			className={classnames('alert alert-fluid alert-info', className)}
			role="alert"
		>
			{children}
		</div>
	);
}

export default Help;
